<div class="agpr-formField agpr-curatedFiltersField">
    <div
        *ngIf="field.label"
        class="agpr-formField-label"
    >
        {{ field.label | localize }}
    </div>
    <div class="agpr-curatedFiltersField-filter">
        <span class="agpr-curatedFiltersField-filterDropdown">
            <agpr-filter-dropdown
                [tooltip]="field.tooltip"
                [id]="'curatedFiltersField'"
                iconClass="fa-regular fa-duotone fa-network-wired"
                [ariaLabel]="field.label | localize"
            ></agpr-filter-dropdown>
        </span>
        <span class="agpr-curatedFiltersField-filterChips">
            <agpr-filter-chips
                [id]="'curatedFiltersFilterchips'"
                [emptyMessage]="field.emptyMessage"
                [overflowMessage]="field.overflowMessage"
            ></agpr-filter-chips>
        </span>
    </div>
    <div
        *ngIf="field.description"
        class="agpr-formField-description"
    >
        {{ field.description | localize }}
    </div>
</div>
